<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.withdraw_address_manage')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <!-- 银行卡 -->
      <div class="crypto-section">
        <div class="section-header">
          <span>{{$t("withdraw.bank_cards")}}</span>
          <van-button v-if="!bankInfo" size="small" type="primary" @click="toBindCard()">
            <van-icon name="plus" />
            {{$t("withdraw.add_bank_card")}}
          </van-button>
        </div>
        <div v-if="bankInfo" class="crypto-list">
          <div class="crypto-item">
            <div class="crypto-header">
              <span class="crypto-type">{{bankInfo.bankinfo}}</span>
            </div>
            <div class="crypto-info">
              <div class="row-content">
                <span class="label">{{$t('withdraw.account_holder')}}：</span>
                <span class="value">{{bankInfo.username}}</span>
              </div>
              <div class="row-content">
                <span class="label">{{$t('withdraw.account_number')}}：</span>
                <span class="value address-text">{{bankInfo.bankid}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-tip">
          <van-empty :description="$t('withdraw.no_bank_card')" />
        </div>
      </div>

      <!-- 加密货币地址 -->
      <div class="crypto-section" style="margin-top:15px;">
        <div class="section-header">
          <span>{{$t("withdraw.crypto_addresses")}}</span>
          <van-button size="small" type="primary" @click="$router.push({path:'/BindCrypto'})">
            <van-icon name="plus" />
            {{$t("withdraw.add_address")}}
          </van-button>
        </div>
        <div v-if="cryptoList.length > 0" class="crypto-list">
          <div v-for="crypto in cryptoList" :key="crypto.id" class="crypto-item">
            <div class="crypto-header">
              <span class="crypto-type">{{crypto.bankinfo}} ({{crypto.bankfenhang}})</span>
            </div>
            <div class="crypto-info">
              <div class="row-content">
                <span class="label">{{$t('setting.username')}}：</span>
                <span class="value">{{crypto.username}}</span>
              </div>
              <div class="row-content">
                <span class="label">{{$t('withdraw.wallet_address')}}：</span>
                <span class="value address-text">{{crypto.bankid}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-tip">
          <van-empty :description="$t('withdraw.no_crypto_address')" />
        </div>
      </div>

      <div class="tips">{{$t("withdraw.crypto_address_tip")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bankInfo: null,
      cryptoList: [],
      userInfo: {}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if(res.code === 200){
          this.bankInfo = res.data.bank_info || null;
          this.cryptoList = res.data.is_crypto ? res.data.crypto_list : [];
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if(res.code === 200){
          this.userInfo = res.data;
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return true;
      } else {
        this.$router.push({path: '/BindCard'})
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

.wrapper{
  height: calc(100% - 10px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 15px;
}

.crypto-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 32px;
  font-weight: 600;
  color: #333;
}

.section-header .van-button {
  font-size: 26px;
  padding: 8px 16px;
  border-radius: 20px;
}

.crypto-list {
  margin-top: 15px;
}

.crypto-item {
  background-color: #f7f8fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
}

.crypto-header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebedf0;
}

.crypto-type {
  font-size: 30px;
  font-weight: 600;
  color: #7e5678;
}

.crypto-info .row-content {
  margin: 12px 0;
  line-height: 40px;
  font-size: 28px;
  display: block;
}

.crypto-info .row-content .label {
  color: #646566;
  font-weight: 500;
  display: inline;
}

.crypto-info .row-content .value {
  color: #323233;
  display: inline;
}

.crypto-info .row-content .address-text {
  word-break: break-all;
  font-family: monospace;
  font-size: 24px;
}

.empty-tip {
  padding: 40px 0;
  text-align: center;
}

.wrapper .tips {
  margin: 20px 0;
  padding: 15px;
  font-size: 25px;
  color: #979799;
  background-color: #fff;
  border-radius: 8px;
}
</style>
